import React from "react";

const AboutUsHeroSection = () =>{
    return(
        <>
        <div className="common-hero">
          <div className="container">
            <div className="row align-items-center text-center">
              <div className="col-lg-6 m-auto">
                <div className="main-heading">
                  <h1>About Us</h1>
                    <div className="space16"></div>
                    <span className="span"><img src="/assets/img/icons/span1.png" alt=""/> <a href="index.html">Home</a> <span className="arrow"><i className="fa-solid fa-angle-right"></i></span> About</span>
                </div>
              </div>

            </div>
          </div>
        </div>
        </>        
    )
}

export default AboutUsHeroSection;